import React, { useState } from 'react';
import { FileDown, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { buildFacesheetPdf } from '../utils/facesheetPdf';
import { authFetch } from './MedicationExtras';

// Builds and downloads one patient's blue Face Sheet, pre-filled from the chart and still editable
export const downloadFaceSheet = async (patient) => {
  let meds = patient.currentMedications;
  const r = await authFetch(`/medications/patient/${patient.id}`).then(x => x.json()).catch(() => null);
  if (r?.medications?.length) meds = r.medications.filter(m => (m.status || 'active').toLowerCase() !== 'discontinued');
  const name = [patient.firstName, patient.lastName].filter(Boolean).join(' ');
  const doc = buildFacesheetPdf({}, {
    patientName: name, dateOfBirth: patient.dateOfBirth, mrn: patient.medicalRecordNumber || patient.pan,
    chart: { ...patient, currentMedications: meds },
  });
  doc.fillMode = 'prefill';
  doc.save(`Face_Sheet_${(name || 'patient').replace(/\s+/g, '_')}.pdf`);
};

export const FaceSheetButton = ({ patient }) => {
  const [busy, setBusy] = useState(false);
  const download = async () => {
    setBusy(true);
    try { await downloadFaceSheet(patient); toast.success('Face Sheet downloaded'); }
    catch { toast.error('Could not create the Face Sheet'); }
    finally { setBusy(false); }
  };
  return (
    <button onClick={download} disabled={busy} data-testid="download-facesheet-btn"
      className="px-4 py-2 bg-[#1e40af] text-white rounded hover:bg-[#1e3a8a] flex items-center gap-2 disabled:opacity-50">
      {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <FileDown className="w-4 h-4" />}
      Face Sheet
    </button>
  );
};
